import React from 'react';
import classNames from 'classnames';
import _isEmpty from 'lodash/isEmpty';

import GenderEthnicLanguageDiversity from '../GenderEthnicLanguageDiversity';
import GenderOverTime from '../GenderOverTime';
import GenderRatioComparison from '../GenderRatioComparision';
import IncomeByGender from '../salaryEstimates/IncomeByGender';

import classes from './index.module.css';

const GenderStatistics = ({
  jobTitle,
  jobTitlePlural,
  genderPieChart,
  genderSectionContentBlurb,
  salaryEstimates,
  genderOverTime,
  genderOverTimeContentBlurb,
  filterLogEventCallback,
  filterValueRange,
  genderRatio,
  compareGenderContentBlurb,
  jobsIndex,
  locations,
}) => {
  return (
    <section
      id="gender-statistics"
      className={classNames(classes.genderStatisticsContainer, 'w-730')}
    >
      <h2 className="brandonH2 w-730 z-mb-48">{`${jobTitle} gender statistics`}</h2>
      {genderPieChart && (
        <>
          <GenderEthnicLanguageDiversity
            jobTitle={jobTitle}
            jobTitlePlural={jobTitlePlural}
            genderSetionContentBlurb={genderSectionContentBlurb}
            pieChartData={[genderPieChart]}
            filterLogEventCallback={filterLogEventCallback}
            filterValueRange={filterValueRange}
            noTitle
            locations={locations}
          />
          <div className="section-separator-medium"></div>
        </>
      )}

      {salaryEstimates && salaryEstimates.byGender && !_isEmpty(salaryEstimates.byGender) && (
        <IncomeByGender
          outsideTitle={`${jobTitle} gender pay gap`}
          title={`${jobTitle} gender pay gap`}
          jobTitle={jobTitle}
          incomeByGender={salaryEstimates.byGender}
        />
      )}

      {genderOverTime && (
        <GenderOverTime
          jobTitle={jobTitle}
          genderOverTime={genderOverTime}
          genderOverTimeContentBlurb={genderOverTimeContentBlurb}
        />
      )}

      {genderRatio && (
        <GenderRatioComparison
          filterLogEventCallback={filterLogEventCallback}
          filterValueRange={filterValueRange}
          jobTitle={jobTitle}
          genderRatio={genderRatio}
          compareGenderContentBlurb={compareGenderContentBlurb}
          jobsIndex={jobsIndex}
        />
      )}
    </section>
  );
};

export default GenderStatistics;
